import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconSearch } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { useRef } from 'react';
import { ClearIcon } from '../../../../../../components/SearchForm/components/ClearIcon.js';
import { Container } from '../../../../../../components/SearchForm/components/DestinationWidget/components/List/components/Container.js';
import { TextFieldWrapper } from '../../../../../../components/SearchForm/components/DestinationWidget/components/List/components/TextFieldWrapper.js';
import { WidgetOverlay } from '../../../../../../components/SearchForm/components/WidgetOverlay/index.js';
import { Stack, TextField } from '../../../../../../primitives/index.js';
export const List = ({
  children,
  type,
  layout,
  open,
  invalid,
  searchTerm,
  widgetHead,
  containerRef,
  getInputProps,
  onClear,
  onClose,
  dimming = false,
  ...restProps
}) => {
  const {
    t
  } = useTranslation();
  const inputRef = useRef(null);
  return _jsx(WidgetOverlay, {
    type: type,
    open: open,
    dim: dimming || layout === 'compact' || layout === 'sidebar',
    children: _jsx(Container, {
      ...restProps,
      ref: containerRef,
      type: type,
      head: widgetHead,
      title: t('searchField:title.dialog'),
      topControls: (type === 'drawer' || layout === 'compact' || layout === 'sidebar') && _jsx(TextFieldWrapper, {
        withElevation: type === 'drawer',
        children: _jsx(TextField, {
          ...getInputProps(),
          inputRef: inputRef,
          placeholder: t('searchForm:searchField.placeholder'),
          appendIcon: searchTerm ? _jsx(ClearIcon, {
            onClick: onClear
          }) : undefined,
          prependIcon: _jsx(IconSearch, {}),
          variant: invalid ? 'warning' : undefined
        })
      }),
      onClose: onClose,
      "data-testid": "destination-widget",
      children: _jsx(Stack, {
        children: children
      })
    })
  });
};